// @ts-expect-error - TS2614 - Module '"src/api-parsers/index"' has no exported member 'Workflow'. Did you mean to use 'import Workflow from "src/api-parsers/index"' instead?
import type {Workflow} from 'src/api-parsers/index';
import type {Router} from 'src/types/router';
import type {ModalType} from 'src/components/modals/modal-root';
import * as React from 'react';

import FluxComponent from 'src/flux/component';
import {TitleBarModal} from 'src/components/modals/base-modal-design-system-2021';
import {Paragraph} from 'src/designSystem2021Components/text-v2';

import {deleteWorkflow} from 'src/actions/workflow';

/**(diwakersurya) copied from delete-modal to suit the needs of organizer */
// @ts-expect-error - TS7031 - Binding element 'store' implicitly has an 'any' type. | TS7031 - Binding element 'id' implicitly has an 'any' type.
const mapper = ({store, workflow: {id}}) => ({
  deletingWorkflow: Boolean(store.request.inProgress(`deleteWorkflow/${id}`)),
});

class WorkflowDeleteModal extends React.Component<{
  store: any;
  router: Router;
  workflow: Workflow;
  removeModal: () => void;
  deletingWorkflow: boolean;
  type: ModalType;
}> {
  constructor(props: any) {
    super(props);

    (this as any).handleDelete = this.handleDelete.bind(this);
  }

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<{ store: any; router: BaseHistory; workflow: Workflow; removeModal: () => void; deletingWorkflow: boolean; type: any; }, {}, any>'.
  render() {
    const {deletingWorkflow, removeModal, type} = this.props;
    return (
      <TitleBarModal
        title={'Really delete this journey?'}
        confirmText={deletingWorkflow ? 'Deleting...' : 'Yes, delete it'}
        handleConfirm={this.handleDelete}
        abortText={'Keep it'}
        handleAbort={removeModal}
        {...this.props}
        type={'GENERIC_INFO_DS_2021'}
      >
        <Paragraph style={{padding: '20px 20px 40px 20px'}}>
          Once you delete it, all the journey information will be lost. Any data
          collected so far will remain available in Analytics.
        </Paragraph>
      </TitleBarModal>
    );
  }

  handleDelete(event: React.SyntheticEvent) {
    const {store, workflow, removeModal} = this.props;
    event.preventDefault();
    // @ts-expect-error - TS18046 - 'deleteWorkflow' is of type 'unknown'.
    deleteWorkflow(store, workflow).then(() => {
      removeModal();
    });
  }
}

// @ts-expect-error - TS7022 - 'default' implicitly has type 'any' because it does not have a type annotation and is referenced directly or indirectly in its own initializer.
export default FluxComponent(
  WorkflowDeleteModal,
  mapper,
) as React.ComponentType<{
  workflow: Workflow;
  removeModal: () => void;
  type: ModalType;
}>;
